module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_8017.d4c3615c.png";